import { Badge, Button } from "@pej/kore/components";
import { Plus } from "lucide-react";
import { OrgAvatar } from "@/components/common/org-avatar";
import type { SelectorGroup } from "@/contexts/workspace-derivation";
import { getOrgColor } from "@/lib/org/org-color";
import { WorkspaceRow } from "./workspace-row";

interface OrgSectionProps {
    group: SelectorGroup;
    recentId: string | null;
    onSelect: (id: string) => void;
    onCreate: (organization: SelectorGroup["organization"]) => void;
}

export function OrgSection({ group, recentId, onSelect, onCreate }: OrgSectionProps) {
    const { organization, workspaces, canCreateWorkspace, role } = group;
    const isEmpty = workspaces.length === 0;

    return (
        <section className="mt-6 first:mt-0">
            <div className="mb-3 flex items-center gap-2.5">
                <OrgAvatar color={getOrgColor(organization.colorIndex)} size="sm" />
                <span className="flex-1 truncate text-sm font-semibold text-foreground">{organization.name}</span>
                <Badge variant="outline" className="uppercase tracking-[0.08em] text-[11px] font-semibold">
                    {role}
                </Badge>
                {canCreateWorkspace && !isEmpty && (
                    <Button variant="outline" size="sm" onClick={() => onCreate(organization)}>
                        <Plus />
                        New workspace
                    </Button>
                )}
            </div>
            {isEmpty ? (
                <div className="flex items-center justify-between gap-3 rounded-md border border-border bg-card px-4 py-3.5 text-sm text-muted-foreground">
                    <span>No workspaces in this organization yet.</span>
                    <Button variant="outline" size="sm" onClick={() => onCreate(organization)}>
                        <Plus />
                        Create one
                    </Button>
                </div>
            ) : (
                <div className="overflow-hidden rounded-md border border-border bg-card">
                    {workspaces.map((ws) => (
                        <WorkspaceRow key={ws.id} workspace={ws} isRecent={ws.id === recentId} onSelect={onSelect} />
                    ))}
                </div>
            )}
        </section>
    );
}
